import React, { ReactNode } from "react";
import { FaSearch } from "react-icons/fa";
import { ORANGE } from "../../shared/colors";


export const NothingFound = ({ text, icon, size }: { text?: string | ReactNode; icon?: ReactNode; size?: number; }) => {
    return (<div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column",width:"-webkit-fill-available" }}>{icon || <FaSearch size={size || 150} color={ORANGE} />}<p style={{
        fontFamily: 'Poppins-B',
        fontSize: 20,
    }}>{text || "Aucun Post trouvé"}</p></div>);
};
